import React, { Component } from "react";
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBCard,
    MDBCardBody,
    MDBBtn,
} from "mdbreact";
import Select from "react-select";

class Report_wawancara_pusat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            val_studyyear: "",
            valueYear: {},
            valueDataUnit: {},
        };
    }

    componentDidMount() {
        fetch(global.variable.LINK_API + 'auth/parameter', {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + global.cookies.get("access_token"),
            },
        })
            .then((response) => response.json())
            .then((resData) => {
                if (resData.message === "Success") {
                    localStorage.setItem("DATA_PARAMETER", JSON.stringify(resData.data));
                }
            });
        this.fetchDataUnit();
    }

    async fetchDataUnit() {
        var dataUnit = JSON.parse(localStorage.getItem('DATA_PARAMETER')).prm_unit;
        await fetch(global.variable.LINK_API + 'unit/list-by-organizations', {
            method: "post",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + global.cookies.get("access_token"),
            },
            body: JSON.stringify({
                org_id: dataUnit.organizations_id,
            })
        })
            .then((response) => response.json())
            .then((resData) => {
                if (resData.code === 200) {
                    this.setState({ valueDataUnit: resData.data });
                }
            });
    }

    createSelectItemsStudyYear() {
        let items = [];
        var data = JSON.parse(localStorage.getItem("DATA_PARAMETER")).prm_study_year;
        for (let i = 0; i < data.length; i++) {
            items.push(
                {
                    value: data[i].id,
                    label: data[i].name
                }
            );
        }
        return <Select options={items} isClearable onChange={e => this.onDropdownSelected2('valueYear', e)} placeholder="- Pilih Tahun -" />;
    }

    onDropdownSelected2(name, e) {
        const value = e ? e.value : {};
        this.setState({ [name]: value });
    }

    createSelectUnit() {
        let items = [];
        var data = this.state.valueDataUnit;
        for (let i = 0; i < data.length; i++) {
            items.push(
                {
                    value: data[i].subdomain,
                    label: data[i].name
                }
            );
        }
        return <Select options={items} isClearable onChange={e => this.onDropdownSelected2('valueUnit', e)} placeholder="- Pilih Unit -" />;
    }

    handleSubmit = event => {
        event.preventDefault();
        let params = '';
        if (this.state.valueUnit !== '') {
            params += this.state.valueUnit + '/';
        }
        if (typeof this.state.valueYear === 'number') {
            params += this.state.valueYear;
        }
        localStorage.setItem('pusat_data', JSON.stringify(params));
        this.props.history.push("/reportwawancarapusatdetail")
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="divContainter">
                                    <MDBCard className="mb-5">
                                        <MDBCardBody>
                                            <MDBBreadcrumb color="cyan lighten-4">
                                                <MDBBreadcrumbItem active>
                                                    <a href="/home">Home</a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    Laporan Wawancara Pusat
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>

                                            <form onSubmit={this.handleSubmit}>
                                                <div className="form-group">
                                                    <label htmlFor="exampleForm2">Pilih Unit <span style={{ color: 'red' }}>*</span></label>
                                                    {this.createSelectUnit()}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="exampleForm2">Pilih Tahun</label>
                                                    {this.createSelectItemsStudyYear()}
                                                </div>
                                                <MDBBtn color="primary" block type="submit">
                                                    lanjut
                                                </MDBBtn>
                                            </form>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Report_wawancara_pusat;
